import { Link } from "react-router-dom";
import { ChevronRight, Phone } from "lucide-react";
import SeoHead from "../components/SeoHead";
import CTABand from "../components/CTABand";
import { PageHeader } from "./Services";
import { SITE } from "../lib/site";

// 30+ Q/A stratégiques couvrant des centaines de long-tail keywords locales.
// Chaque paire Q/A cible une intention de recherche typique.
const LOCAL_QA = [
  {
    q: "Quelle est la meilleure entreprise pour un traitement anti-termites à Bordeaux ?",
    a: "Termite Habitat 33 est le cabinet local de référence pour le traitement anti-termites à Bordeaux et en Gironde. Note Google 5/5, garantie 5 ans, applicateur certifié CTB-P+. Devis gratuit en 24 h au 07 45 71 15 10.",
    keys: ["meilleure entreprise termites Bordeaux","entreprise anti termites Bordeaux","société traitement termites Bordeaux","professionnel termites Gironde"],
  },
  {
    q: "Combien coûte un traitement termites à Bordeaux ?",
    a: "Le prix d'un traitement termites Bordeaux démarre à environ 50 €/m² traité en curatif (injection ou pièges-appâts). Le tarif final dépend de la surface, du type de bois et du niveau d'infestation. Devis gratuit sur place.",
    keys: ["prix traitement termites Bordeaux","tarif termites Gironde","coût traitement anti-termite Bordeaux","devis termites Bordeaux"],
  },
  {
    q: "Combien coûte l'injection anti-termites à Bordeaux ?",
    a: "L'injection anti-termites à Bordeaux se facture entre 50 et 90 € HT du mètre carré selon la nature des bois (chêne, pin), leur accessibilité et le protocole (à cœur ou surface). Un devis précis est remis après visite gratuite.",
    keys: ["prix injection anti termites","coût injection charpente Bordeaux","tarif injection bois termites"],
  },
  {
    q: "Comment savoir si j'ai des termites dans ma maison à Bordeaux ?",
    a: "Cinq signes doivent alerter : des cordonnets de terre sur les murs, des termites ailés au sol au printemps, un son creux au sondage des bois, une sciure fine sous les poutres et des dégâts visibles sur plinthes ou huisseries. Toute suspicion mérite une expertise rapide.",
    keys: ["comment savoir termites Bordeaux","signes termites maison","reconnaître termites Bordeaux","détecter termites Gironde"],
  },
  {
    q: "Le traitement anti-termites est-il obligatoire en Gironde ?",
    a: "La Gironde est classée « zone contaminée par les termites » par arrêté préfectoral. Toute vente immobilière déclenche l'obligation d'un état parasitaire (validité 6 mois) réalisé par un diagnostiqueur certifié. Nous, cabinet Termite Habitat 33, intervenons ensuite pour appliquer le traitement adapté à l'infestation constatée.",
    keys: ["traitement termites obligatoire Gironde","état parasitaire Bordeaux","obligation termites vente maison Bordeaux"],
  },
  {
    q: "Quelle est la garantie sur un traitement anti-termites ?",
    a: "Termite Habitat 33 propose une garantie 5 ans avec retraitement gratuit en cas de nouvelle infestation dans les zones traitées. Elle couvre les termites souterrains et est adossée à notre assurance responsabilité civile professionnelle.",
    keys: ["garantie traitement termites Bordeaux","garantie 5 ans termites","assurance traitement termites"],
  },
  {
    q: "Combien de temps dure un traitement anti-termites à Bordeaux ?",
    a: "Un chantier standard sur charpente et murs porteurs dure entre 1 et 3 jours selon la surface. Le retour au logement est possible dès les vapeurs dissipées (4 à 24 h après la fin d'application selon les zones).",
    keys: ["durée traitement termites","délai intervention termites Bordeaux","combien de temps injection termites"],
  },
  {
    q: "Quelle différence entre termites, capricornes et vrillettes ?",
    a: "Les termites (Reticulitermes flavipes) sont des insectes sociaux souterrains qui laissent des cordonnets de terre. Les capricornes (Hylotrupes bajulus) sont des coléoptères qui creusent de larges galeries dans les résineux. Les vrillettes (Anobium punctatum) laissent de petits trous ronds et de la sciure fine. Chaque cas demande un protocole spécifique.",
    keys: ["différence termites capricornes vrillettes","identifier insecte xylophage","xylophages bois Bordeaux"],
  },
  {
    q: "Peut-on faire soi-même un traitement anti-termites ?",
    a: "Non — les produits professionnels CTB-P+ sont réservés aux applicateurs certifiés. Un traitement en surface acheté en grande surface ne pénètre pas à cœur du bois et n'atteint pas la reine de la colonie. Une intervention professionnelle est indispensable.",
    keys: ["traitement termites soi-même","produit anti termites particulier","spray termites efficace"],
  },
  {
    q: "Quelles sont les zones de Bordeaux les plus touchées par les termites ?",
    a: "Les quartiers historiques (Chartrons, Saint-Michel, Saint-Pierre) et les communes proches de la Garonne (Bègles, Cenon, Lormont) sont particulièrement exposés. Les caves voûtées et le bâti ancien favorisent l'installation des colonies.",
    keys: ["quartiers Bordeaux termites","Chartrons termites","Saint-Michel termites Bordeaux","Bègles termites","Cenon termites"],
  },
  {
    q: "Peut-on vendre une maison avec des termites à Bordeaux ?",
    a: "Oui, à condition de joindre au dossier de vente un état parasitaire de moins de 6 mois et de déclarer en mairie la présence de termites. Un traitement en cours ou terminé, appuyé par notre garantie 5 ans, rassure les acheteurs.",
    keys: ["vendre maison termites Bordeaux","vente immobilière termites Gironde","déclaration termites mairie"],
  },
  {
    q: "Faut-il déclarer les termites en mairie ?",
    a: "Oui — l'article L.133-4 du code de la construction impose à tout propriétaire de déclarer en mairie la présence de termites constatée dans son bien, dans le mois qui suit la constatation. Notre cabinet accompagne ses clients dans cette démarche.",
    keys: ["déclaration termites mairie Bordeaux","obligation déclarer termites","procédure termites Gironde"],
  },
  {
    q: "Le traitement anti-termites est-il dangereux pour ma famille ?",
    a: "Les produits utilisés sont certifiés CTB-P+ et appliqués par des techniciens équipés. Les zones traitées sont ventilées, et le retour dans le logement est possible sous quelques heures. Enfants, animaux et personnes sensibles doivent être absents durant l'application.",
    keys: ["traitement termites dangereux","toxicité anti termites","sécurité produits termites"],
  },
  {
    q: "Traitement termites par injection ou par pièges-appâts : quelle méthode choisir ?",
    a: "L'injection à cœur est privilégiée en cas d'infestation active et visible (charpente attaquée). Les pièges-appâts Termigard sont préférés en préventif ou en contexte contraint (copropriété, patrimoine). Nos experts vous conseillent la méthode la plus adaptée après visite.",
    keys: ["injection ou pièges termites","méthode traitement termites","Termigard System Bordeaux"],
  },
  {
    q: "Peut-on traiter la mérule en même temps que les termites ?",
    a: "Oui. Notre cabinet traite mérule (Serpula lacrymans), termites et humidité dans un protocole global. La mérule prospère dans les mêmes conditions d'humidité que les termites souterrains — l'assèchement fait partie intégrante de nos interventions.",
    keys: ["mérule Bordeaux","Serpula lacrymans Gironde","traitement mérule et termites","champignon lignivore Bordeaux"],
  },
  {
    q: "Combien de temps avant de refaire un traitement anti-termites ?",
    a: "Un traitement curatif par injection est couvert par notre garantie 5 ans. En prévention, un contrôle annuel est recommandé pour les bâtiments antérieurs à 1990. Un renouvellement complet peut être envisagé après 8 à 10 ans.",
    keys: ["fréquence traitement termites","renouvellement anti termites","contrôle annuel termites"],
  },
  {
    q: "Intervenez-vous au Bassin d'Arcachon (Arcachon, La Teste, Andernos) ?",
    a: "Oui, l'ensemble du Bassin d'Arcachon fait partie de notre zone d'intervention : Arcachon, La Teste-de-Buch, Andernos-les-Bains, Gujan-Mestras, Le Teich, Biganos, Lège-Cap-Ferret, Arès, Audenge et Marcheprime. Devis gratuit sous 24 h.",
    keys: ["termites Arcachon","traitement termites Bassin d'Arcachon","La Teste termites","Cap-Ferret termites"],
  },
  {
    q: "Intervenez-vous dans le Médoc (Pauillac, Lesparre) ?",
    a: "Oui, le Médoc est couvert par notre cabinet : Pauillac, Lesparre-Médoc, Castelnau-de-Médoc, Saint-Aubin-de-Médoc, Le Taillan-Médoc, Macau. Nous connaissons parfaitement le bâti viticole ancien de la zone.",
    keys: ["termites Médoc","Pauillac termites","Lesparre traitement termites"],
  },
  {
    q: "Intervenez-vous dans le Libournais et l'Entre-deux-mers ?",
    a: "Oui, nous couvrons Libourne, Saint-André-de-Cubzac, Sainte-Eulalie, Saint-Loubès, Bassens, ainsi que l'ensemble de l'Entre-deux-mers et du Libournais.",
    keys: ["termites Libourne","Libournais traitement bois","Entre-deux-mers termites"],
  },
  {
    q: "Quel est le délai pour recevoir un devis ?",
    a: "Nous rappelons systématiquement sous 24 h ouvrées. Après visite gratuite sur site, le devis chiffré est remis sous 48 h en moyenne, avec estimation détaillée des surfaces, produits et durée de garantie.",
    keys: ["délai devis termites Bordeaux","obtenir devis termites","délai intervention Bordeaux"],
  },
  {
    q: "Peut-on traiter uniquement une partie de la maison ?",
    a: "Oui, en cas d'infestation localisée. Notre cabinet privilégie néanmoins un diagnostic global avant traitement partiel, car les colonies de termites souterrains s'étendent souvent au-delà des zones apparentes. Un traitement complet est plus fiable en curatif.",
    keys: ["traitement partiel termites","zone traitement anti termites","injection localisée termites"],
  },
  {
    q: "Que faire en cas d'essaimage de termites au printemps ?",
    a: "L'essaimage (mars-mai) est le signe visible d'une colonie mature installée depuis plusieurs années. Récupérez quelques individus dans un pot, ne balayez pas immédiatement, et appelez-nous au 07 45 71 15 10 : nous intervenons en urgence.",
    keys: ["essaimage termites Bordeaux","termites ailés printemps","urgence essaimage Gironde"],
  },
  {
    q: "Le traitement anti-termites est-il déductible fiscalement ?",
    a: "Pour une résidence principale, les travaux de traitement anti-termites peuvent parfois être intégrés dans une opération globale éligible à MaPrimeRénov' (rénovation énergétique). Pour un bien locatif, ils sont déductibles des revenus fonciers. Notre cabinet peut vous fournir les factures détaillées nécessaires.",
    keys: ["traitement termites impôts","déduction fiscale termites","aide traitement termites Bordeaux"],
  },
  {
    q: "Que dois-je faire pendant l'intervention de traitement ?",
    a: "Libérer les zones à traiter (dégager les combles, protéger les meubles), quitter le logement pendant l'application, et prévoir un retour après 4 à 24 h selon les produits utilisés. Un descriptif complet vous est remis avec le devis.",
    keys: ["préparation traitement termites","déroulement intervention termites","que faire pendant traitement"],
  },
  {
    q: "Peut-on éradiquer complètement les termites ?",
    a: "Oui, avec un protocole professionnel adapté (injection à cœur des bois structurels + barrière chimique périphérique + pièges-appâts en surveillance). Notre garantie 5 ans avec retraitement gratuit couvre justement le risque de retour éventuel.",
    keys: ["éradiquer termites Bordeaux","supprimer termites définitivement","efficacité traitement anti termites"],
  },
  {
    q: "Combien de temps met une colonie de termites à détruire une maison ?",
    a: "Les termites souterrains dégradent le bois à un rythme lent mais continu. Une colonie mature peut affaiblir une charpente en 3 à 8 ans sans traitement. Plus le diagnostic est précoce, moins les réparations sont lourdes.",
    keys: ["dégâts termites maison","délai destruction termites","dommages termites Bordeaux"],
  },
  {
    q: "Quels sont les meilleurs pièges à termites ?",
    a: "Les stations Termigard System sont la référence professionnelle : bois-appâts imprégnés d'inhibiteur de croissance (hexaflumuron), pose en périmètre ou fixation sur poutres via boîtiers Wall Box, surveillance trimestrielle. La colonie disparaît par arrêt de mue.",
    keys: ["pièges termites Bordeaux","Termigard System Gironde","stations appâts termites"],
  },
  {
    q: "Faites-vous des traitements écologiques anti-termites ?",
    a: "Les pièges-appâts Termigard sont la méthode la plus « propre » : quelques grammes de matière active par station, aucun rejet dans l'air ni dans le sol, transmission cible sur la colonie. Idéal en zone habitée et pour la biodiversité.",
    keys: ["traitement termites écologique","anti termites bio Bordeaux","méthode naturelle termites"],
  },
  {
    q: "Le traitement anti-termites protège-t-il aussi contre les capricornes ?",
    a: "Les protocoles diffèrent. Un traitement anti-termites (fipronil, chlorfénapyr) ne cible pas les larves de capricornes. Nous appliquons des insecticides polyvalents CTB-P+ quand les deux espèces cohabitent — fréquent en charpente ancienne bordelaise.",
    keys: ["traitement termites et capricornes","polyvalent xylophages","cohabitation insectes bois"],
  },
  {
    q: "Peut-on traiter les termites en immeuble collectif ou copropriété ?",
    a: "Oui — le syndic mandate le traitement, souvent sur périmètre extérieur (barrière chimique) et parties communes. Nous intervenons dans plusieurs copropriétés bordelaises et fournissons rapports détaillés et attestations pour les procès-verbaux.",
    keys: ["termites copropriété Bordeaux","syndic termites Gironde","immeuble collectif termites"],
  },
  {
    q: "Combien de fois par an faut-il inspecter sa charpente ?",
    a: "Nous recommandons une inspection visuelle une fois par an au printemps, période d'activité maximale des termites et xylophages. Un contrôle professionnel tous les 3 à 5 ans est également conseillé pour tout bâti antérieur à 1990.",
    keys: ["inspection charpente Bordeaux","contrôle bois annuel","fréquence expertise charpente"],
  },
];

export default function LocalFAQ() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: LOCAL_QA.map((qa) => ({
      "@type": "Question",
      name: qa.q,
      acceptedAnswer: { "@type": "Answer", text: qa.a },
    })),
  };

  return (
    <div data-testid="local-faq-page">
      <SeoHead
        title="FAQ locale — Traitement termites Bordeaux & Gironde | Termite Habitat 33"
        description="30+ réponses locales aux questions les plus fréquentes sur le traitement termites, capricornes, mérule et humidité à Bordeaux, Bordeaux Métropole, Bassin d'Arcachon, Médoc et Gironde. Prix, obligations, garantie 5 ans."
        canonical={SITE.url + "/questions-frequentes-locales"}
        keywords={[
          "FAQ termites Bordeaux",
          "questions traitement termites Gironde",
          "prix traitement termites Bordeaux",
          "obligation termites Gironde",
          "quartiers Bordeaux termites",
          "termites Arcachon",
          "termites Médoc",
          "termites Libourne",
          "essaimage termites",
          "Termigard System Bordeaux",
          "garantie 5 ans termites",
          "capricornes vrillettes différence",
          "mérule Bordeaux",
        ]}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "FAQ locale Bordeaux Gironde", url: SITE.url + "/questions-frequentes-locales" },
        ]}
        schema={faqSchema}
      />

      <PageHeader
        eyebrow="Questions fréquentes locales"
        title="Traitement termites Bordeaux — toutes vos questions."
        intro="30+ réponses expertes aux questions les plus posées sur le traitement anti-termites, capricornes, mérule et humidité à Bordeaux, Bordeaux Métropole, Bassin d'Arcachon, Médoc, Libournais et Entre-deux-mers. Rédigées par le cabinet Termite Habitat 33."
      />

      <section className="container-x py-14" data-testid="local-faq-list">
        <div className="max-w-4xl mx-auto space-y-8">
          {LOCAL_QA.map((qa, i) => (
            <article
              key={i}
              className="border-l-4 border-[#7A2E39] bg-white pl-6 pr-4 py-5 rounded-sm shadow-sm"
              data-testid={`local-faq-item-${i}`}
            >
              <h2 className="font-serif text-2xl text-gray-900 mb-3 leading-snug">{qa.q}</h2>
              <p className="text-gray-800 mb-3 leading-relaxed">{qa.a}</p>
              {qa.keys && (
                <p className="text-[11px] text-gray-500 italic">
                  Recherches associées : {qa.keys.join(" · ")}
                </p>
              )}
            </article>
          ))}
        </div>
      </section>

      <section className="container-x py-14 max-w-3xl text-center">
        <h2 className="font-serif text-3xl text-gray-900 mb-4">
          Votre question ne figure pas dans la liste&nbsp;?
        </h2>
        <p className="text-gray-700 mb-6">
          Notre équipe répond directement à toutes les demandes locales sur Bordeaux et la
          Gironde. Contactez-nous par téléphone ou par le formulaire de devis en ligne.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <a href={`tel:${SITE.phoneRaw}`} className="btn-primary" data-testid="local-faq-call">
            <Phone className="w-4 h-4" /> Appeler {SITE.phone}
          </a>
          <Link to="/devis" className="btn-ghost" data-testid="local-faq-devis">
            Demander un devis gratuit <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
